<script>
    import { state_codes } from "../../globals.js";
    import { api_host, places_store, user_store } from '../../stores.js';
    import { init_data } from '../../init.js';
    import { onMount } from 'svelte';
    import ResponsiveTable from '../../utils/responsivetable3.svelte';
    import Header from "../header.svelte";
    import { push, querystring } from 'svelte-spa-router';
    import IFTAInput from "../../utils/iftainput.svelte";
    import { toast_message } from '../../utils/toast_message.js';
    import { getToken, doFetch } from '../../utils/Fetching.js';
	import Swal from "sweetalert2";
    import { handle_not_subscribed } from '../../utils/format.js';	


    const { auth_type, auth_token, domain_code } = getToken();

    let myself = {};
    user_store.subscribe(value => {
        myself = value;
    });

    let working_states = [];
    let is_busy = false;
    let is_mounted = false;
    let available_new_states = [];
    let selected_state = '';
    let is_show_error = false;
    let is_new = false;

    $: content_title = "Places - States (Location Where Clients Enter Cities and States for Address Search and Instant Price Quote on Your Website's Home Page)";

    onMount(async () => {
        setTimeout(()=>{
            is_mounted = true;
            const params = new URLSearchParams($querystring);
            is_new = params.get('is_new') === 'first';
            if (is_new) {
                toast_message(true, 'Add states and cities', 2000);
            }
        }, 250);

        init_data('places');
    });

    places_store.subscribe(value => {
        let _working_states = [];
        const states = Object.keys(value);
        available_new_states = Object.keys(state_codes).filter(val => !states.includes(val));
        selected_state = available_new_states[0];
        for (let i = 0; i < states.length; i ++) {
            const state = states[i];
            _working_states.push({
                'id': value[state].id,
                's': state,
                'c': value[state].cities.map(_c => _c.city).join(', ')
            });
        }
        working_states = _working_states;
    });

    let table_header_config = [
        {'t': 'State', 'fm': 's', 'a': true},
        {'t': 'Cities', 'fm': 'c', 'a': true, "span": 9},
    ];

    let show_items = [
        {"id": "show", "i": "fas fa-eye", "s": "color: #1c54b2;", "f": (id) => { push("#/Placescities?psid=" + id); }}
    ];
    let action_items = [
        {"id": "delete", "i": "fas fa-trash-alt", "s": "color: #ab003c;", "f": (id) => { deleteState(id); }},
    ];

    let show_new_state = false;

    function closeAndResetItemFields(){
        show_new_state = false;
    }

    let validation_function = () => {
        if (selected_state.length > 0) {
            is_show_error = false;
            return true;
        } else {
            is_show_error = true;
            return false;
        }
    }
    let change_function = (evt) => {
        if (evt.target.value.length > 0) {
            is_show_error = false;
            return true;
        } else {
            is_show_error = true;
            return false;
        }
    }

    async function addNewState() {
        const res = await doFetch(
            `${api_host}/api/landscaper/update/state`,
            'POST',
            { state_name: selected_state, state_code: state_codes[selected_state] },
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );
        console.log(res);
        if (res.status) {
            toast_message(true, res.msg, 2000);
            setTimeout(() => {
                push(`#/Placescities?psid=${res.state_id}&is_new=${is_new ? 'first' : 'no'}`);
                // toast_message(true, 'Add new city', 2000);
            }, 1000);
            init_data('places');
        } else {
            toast_message(false, res.msg || 'Failed', 2000);
        }
    }

	async function deleteState(state_id) {
		Swal.fire({
			title: 'Delete State?',
			buttonsStyling: true,
			confirmButtonClass: "button",
			confirmButtonText: 'OK',
			cancelButtonText: "Cancel",
			showCancelButton: true,
			icon: "success"
		}).then(async (e) => {
			if (e.isConfirmed) {
				const res = await doFetch(
					`${api_host}/api/landscaper/delete/state`,
					'POST',
					{ state_id },
					{ Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
				);
				if (res.status) {
					toast_message(true, res.msg, 2000);
					init_data('places');
				} else {
					toast_message(false, res.msg || 'Failed', 2000);
				}
			}
		});
	}
</script>


<Header bind:title={content_title} bind:is_busy={is_busy} />

<div class="contentholder">    
    <div class="section">
        <div class="invoicetableholder">
            <ResponsiveTable
                num_per_page={100}
                show_items={show_items}
                action_items={action_items}
                action_items_title='Remove'
                refresh_action='places'
                bind:is_busy={is_busy}
                bind:total_items={working_states.length}
                bind:table_header_config={table_header_config}
                bind:table_data={working_states}
            />
        </div>
    </div>

    <div class="buttonholder">
        <button on:click={()=>{
            if (myself['is_subscribed'] !== undefined && !myself['is_subscribed']) {
                handle_not_subscribed(myself.is_authenticated, myself.is_domain_expired);
                return;
            }
            show_new_state = true;
            setTimeout(()=>{
                if (document.getElementsByClassName("selectedcontentholder")[0]) {
                    document.getElementsByClassName("selectedcontentholder")[0].scrollTop = document.getElementsByClassName("selectedcontentholder")[0].scrollHeight;
                }
            }, 200);
        }}>New State</button>
    </div>
    {#if  show_new_state}
    <div class="toolsholder highlight">
        <IFTAInput 
            type='select' 
            label='Select New State'
            select_options={available_new_states}
            name=''
            show_error={is_show_error}
            error_text='Invalid State'
            bind:value={selected_state}
            bind:change_function={change_function}
            bind:validation_function={validation_function}
        />
        <div class="newitembuttonholder">
            <button class="savebutton" on:click={() => { addNewState("new_expense"); }} >Save</button>
            &nbsp;
            <button class="cancelbutton" on:click={() => {
                closeAndResetItemFields();
            }}>Cancel</button>
        </div>
    </div>
    {/if}
</div>

<style>
    :global(.ff .group) {
        margin-left: 5px;
        margin-right: 5px;
    }
    :global(.rowwrap) {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }
    :global(.rowwrap .group) {
        min-width: 200px;
        max-width: 200px;
    }
    :global(.rowwrap .group) {
        min-width: 200px;
        max-width: 200px;
    }
    .contentholder {
        padding: 0px;
    }
    .buttonholder {
        margin-top: 10px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .buttonholder button {
        max-width: 300px;
        /* width: 100%; */
        background-color: #357a38;
        color: white;
    }
    :global(.flatpickr-input) {
        /* background-color: #ff9100; */
        /* color: white; */
        width: 250px;
    }
    .toolsholder {
        width: 100%;
        max-width: 500px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        box-sizing: border-box;
    }
    :global(.toolsholder .group) {
        padding-left: 10px;
        padding-right: 10px;
    }
    .highlight {
        /* border: 1px solid black; */
        padding: 10px;
        box-sizing: border-box;
    }
    .newitembuttonholder {
        margin-left: 10px;
        width: 40%;
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
    }
    .newitembuttonholder button{
        max-width: 100px;
        width: 100px;
        height: 40px;
    }
    .newitembuttonholder button.savebutton{
        color: #1c54b2;
        background-color: white;
    }
    .newitembuttonholder button.cancelbutton{
        color: #b2102f;
        background-color: white;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        :global(.rowwrap) {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: 0px;
            margin: 0px;
        }
        :global(.rowwrap .group) {
            width: 100%;
            min-width: 100%;
            max-width: 100%;
        }
        .contentholder {
            padding: 0px;
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
        }
        .buttonholder {
            /* max-width: 100%; */
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .buttonholder button{
            max-width: 100%;
            width: 100%;
        }
        :global(.flatpickr-input) {
            /* background-color: #ff9100; */
            /* color: white; */
            width: 100%;
        }
        .toolsholder {
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        :global(.toolsholder .group) {
            padding-left: 0px;
            padding-right: 0px;
        }
        .newitembuttonholder {
            margin-left: 0px;
            margin-top: 10px;
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .newitembuttonholder button{
            max-width: 100%;
            width: 100%;
            height: 40px;
        }
        :global(.rowwrap .group) {
            min-width: 100%;
            max-width: 100%;
        }
    }
</style>